var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('modal',{attrs:{"show":_vm.isOpen,"show-close":true},on:{"update:show":function($event){_vm.isOpen=$event}}},[_c('template',{slot:"header"},[_vm._v(" "+_vm._s(_vm.translate("Log Details"))+" ")]),_c('div',[_c('code',{staticStyle:{"color":"#525f7f"}},[_vm._v(_vm._s(_vm.logDetails))])])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }